export const productsObject = {
  NECK_BRACE: {
    name: "Minerve"
  },

  MOLDED_SEAT: {
    name: "Siège moulé"
  },

  OTN: {
    name: "OTN"
  },

  LIFT: {
    name: "Verticalisateur"
  },

  RETOUCHING_REPAIR: {
    name: "Retouche/Réparation"
  },

  SEAT: {
    name: "Selle"
  },

  POSITIONING_SEAT: {
    name: "Selle de positionnement"
  },

  UPPER_LIMB_ORTHOSIS: {
    name: "Orthèse M sup"
  },

  LOWER_LIMB_ORTHOSIS: {
    name: "Orthèse M inf"
  },

  CORSET: {
    name: "Corset"
  }
};
